// @flow
import React from 'react';
import { Grid, GridColumn, GridRow, Icon } from 'semantic-ui-react';
import * as css from './Subscription.module.css';
import classNames from 'classnames/bind';

type PropsType = {
  amount: string,
  price: string,
  info: string,
  selected: boolean,
  label?: string,
  showPrice?: boolean,
};

const Subscription = ({ amount, price, info, selected, label, showPrice = true }: PropsType) => {
  const cx = classNames.bind(css);
  const subscriptionClasses = cx({
    subscription: true,
    selected: selected,
  });

  return (
    <div className={subscriptionClasses}>
      <Grid>
        <GridRow columns={2} verticalAlign={'middle'}>
          <GridColumn width={1}>{selected && <Icon className={css.check} name="check" />}</GridColumn>

          <GridColumn className={css.flex} width={11}>
            {label && <span className={css.label}>{label}</span>}
            <div className={css.data}>
              <p>{amount}</p>
              {showPrice && <p>{price}</p>}
            </div>
            <p className={css.info}>{info}</p>
          </GridColumn>
        </GridRow>
      </Grid>
    </div>
  );
};

export default React.memo(Subscription);
